import {GridWidgetDataField} from './grid-widget-data-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {SelectFilter} from './select-filter';
import {ParseResolver} from '../../interfaces/parse-resolver';
import {SimpleParseResolver} from '../../simple-parse-resolver';
import {OrderedMap} from '../ordered-map';
export class SelectField extends GridWidgetDataField {

  /**
   * Key: What shows up in the UI
   * Value: The value that gets compared.
   */
  selectOptions: OrderedMap<any>;

  /**
   * Creates a sortable map out of a list of data...
   * @param dataRows
   * @returns {OrderedMap<any>}
   */
  static generateOrderedMap(dataRows: Array<any>, objectLookupKey: string): OrderedMap<any> {
    let parser: ParseResolver = new SimpleParseResolver(objectLookupKey);
    let orderedMap: OrderedMap<any> = new OrderedMap();
    let map: {[key: string]: string} = {};
    dataRows.forEach((item) => {
      let dataInItem = parser.resolve(item);
      if (dataInItem != null && dataInItem !== '') {
        map[String(dataInItem).toUpperCase()] = dataInItem;
      }
    });

    let arrayOfStrings = Object.keys(map);
    arrayOfStrings.sort();

    arrayOfStrings.forEach((upperCaseString) => {
      orderedMap.put(map[upperCaseString], upperCaseString);
    });

    return orderedMap;
  }

  constructor(name: string,
              objectLookup: string | ((Object) => any),
              title: string,
              selectOptions: OrderedMap<any>,
              sortOrder?: any) {
    super(name, objectLookup, title, sortOrder);

    this.selectOptions = selectOptions;
  }

  getFilterInstance(): GridWidgetFilter {
    return new SelectFilter(this);
  }

  resolveAsString(dataRow: any): string {
    let dataValue: any = this.resolve(dataRow);
    let matchValue: string | undefined;
    for (let uiValue of this.selectOptions.keys()) {
      if (this.selectOptions.get(uiValue) === dataValue) {
        if (matchValue == null) {
          matchValue = uiValue;
        } else {
          console.error('selectOptions has multiple keys for the same value: ' + dataValue);
        }
      }
    }

    return matchValue || '';
  }
}
